import axios from '@/helpers/axios';
import dataStore from '@/helpers/data';
import helperError from '@/helpers/error';
import language from '@/helpers/language';
import router from '@/router';
const state = { hasAuthCode: false, matchToken: '' };
const getters = {
  steam: (state) => state,
};
const actions = {
  async getMatchTokens({ commit }) {
    const data = dataStore.getter(this.getters);
    let token = localStorage.getItem('user') || data.user.token || null;
    return await axios.get('/steam/matchtokens', { headers: { userToken: token } }).then(
      (response) => {
        const r = (response.data && response.data.response) || {};
        commit('SET_MATCH_TOKENS', { hasAuthCode: !!r.hasAuthCode, matchToken: r.matchToken || '' });
      },
      () => {}
    );
  },
  async saveMatchTokens({ commit }, parameters) {
    this.dispatch('app/loading', true);
    const data = dataStore.getter(this.getters);
    let token = localStorage.getItem('user') || data.user.token || null;
    return await axios
      .post('/steam/matchtokens', { auth_code: parameters.auth_code, match_token: parameters.match_token }, { headers: { userToken: token } })
      .then(
        () => {
          this.dispatch('app/loading', false);
          commit('SET_MATCH_TOKENS', { hasAuthCode: true, matchToken: parameters.match_token });
          this.dispatch('notification/text', { type: 'success', msg: language(dataStore.language.current)['matchTokensSaved'], persist: false });
        },
        (error) => {
          this.dispatch('app/loading', false);
          const detail = error && error.response && error.response.data && error.response.data.error;
          if (detail) {
            this.dispatch('notification/text', { type: 'error', msg: detail, persist: false });
          } else {
            helperError(this, error, language(dataStore.language.current)['errorOccured']);
          }
          throw error;
        }
      );
  },
  async auth() {
    this.dispatch('app/loading', true);
    const data = dataStore.getter(this.getters);
    let token = null;
    if (localStorage.getItem('user') !== undefined && localStorage.getItem('user') !== null && localStorage.getItem('user') !== '') {
      token = localStorage.getItem('user');
    } else if (data.user.token !== '') {
      token = data.user.token;
    }
    return await axios.get('/steam/authorize', { headers: { userToken: token } }).then(
      (response) => {
        if (response.data.response.authorizeUrl) {
          window.location.href = response.data.response.authorizeUrl;
        }
      },
      (error) => {
        helperError(this, error, language(dataStore.language.current)['errorOccured']);
      }
    );
  },
  async validate({ commit }, parameters) {
    this.dispatch('app/loading', true);
    const data = dataStore.getter(this.getters);
    let token = null;
    if (localStorage.getItem('user') !== undefined && localStorage.getItem('user') !== null && localStorage.getItem('user') !== '') {
      token = localStorage.getItem('user');
    } else if (data.user.token !== '') {
      token = data.user.token;
    }
    return await axios
      .post('/steam/authorize', { claimed_id: parameters.claimed_id, identify: parameters.identify, sig: parameters.sig }, { headers: { userToken: token } })
      .then(
        (response) => {
          this.dispatch('app/loading', false);
          if (data.user.token === '') {
            this.dispatch('notification/text', { type: 'success', msg: 'You have been logged on.', persist: false });
            this.dispatch('user/setToken', response.data.response.userToken);
          } else {
            this.dispatch('notification/text', { type: 'success', msg: 'Steam has been connected.', persist: false });
          }
          this.dispatch('user/setSteam', true);
          commit('SET_STEAM');
          router.push({ name: 'ViewUserInfo' });
        },
        (error) => {
          helperError(this, error, language(dataStore.language.current)['errorOccured']);
        }
      );
  },
};
const mutations = {
  SET_STEAM() {},
  SET_MATCH_TOKENS(state, payload) {
    state.hasAuthCode = payload.hasAuthCode;
    state.matchToken = payload.matchToken;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
